import React from 'lib/react';
import { EVGrid } from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useSelector } from 'lib/redux';
import {
  PRODUCT_FAMILY_ID_EVCORE,
  SUBSTITUTION_QUESTIONS_VISIBLE_FOR_EVCORE,
} from 'constants/AppConstants';
import { PRODUCT_SUBSTITUTION_QUESTIONS } from './ProductSubstitutions.constants';
import ProductSubstitutionsStyles from './ProductSubstitutionsStyles';
import ProductSubstitutionQuestion from './components/ProductSubstitutionQuestion.component';
import PageHeading from '../PageHeading.component';

function ProductSubstitutions() {
  const { t } = useTranslation();
  const classes = ProductSubstitutionsStyles();
  const productFamilyId = useSelector(({ userData }) => userData?.initParameters?.productFamilyId);
  const questions = productFamilyId === PRODUCT_FAMILY_ID_EVCORE
    ? PRODUCT_SUBSTITUTION_QUESTIONS.filter((key) => SUBSTITUTION_QUESTIONS_VISIBLE_FOR_EVCORE.includes(key))
    : PRODUCT_SUBSTITUTION_QUESTIONS;

  return (
    <>
      <PageHeading
        title={t('order_preferences__product_substitutions')}
        description={t('order_preferences__product_substitutions_description')}
      />
      <EVGrid className={classes.productSubstitutionsContentContainer}>
        <EVGrid className={classes.productsAndDeliveryContentBox}>
          {questions.map((propertyName) => (
            <ProductSubstitutionQuestion
              propertyName={propertyName}
              key={propertyName}
            />
          ))}
        </EVGrid>
      </EVGrid>
    </>
  );
}

export default ProductSubstitutions;
